var _path, _line, _line2, _path2, _line3, _line4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3225 8.83203H20.1736C13.8171 8.83203 8.66406 13.985 8.66406 20.3416V32.4905C8.66406 38.847 13.8171 44 20.1736 44H32.3225C38.6791 44 43.8321 38.847 43.8321 32.4905V20.3416C43.8321 13.985 38.6791 8.83203 32.3225 8.83203Z",
    fill: "url(#paint0_linear_945_158)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27.0718,
    y1: 21.8292,
    x2: 27.0718,
    y2: 32.3554,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 31.8493,
    y1: 27.5779,
    x2: 21.3231,
    y2: 27.5779,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8493 0.167969H15.9807C7.15482 0.167969 0 7.32278 0 16.1487V33.0172C0 41.8432 7.15482 48.998 15.9807 48.998H32.8493C41.6752 48.998 48.83 41.8432 48.83 33.0172V16.1487C48.83 7.32278 41.6752 0.167969 32.8493 0.167969Z",
    fill: "url(#paint1_linear_945_158)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24.968,
    y1: 16.5,
    x2: 24.968,
    y2: 33.82,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33.652,
    y1: 25.136,
    x2: 16.332,
    y2: 25.136,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_945_158",
    x1: 26.2481,
    y1: 8.83203,
    x2: 26.2481,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E0B59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161B41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_945_158",
    x1: 24.415,
    y1: 0.167969,
    x2: 24.415,
    y2: 48.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E0B59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161B41"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEvent);
export default __webpack_public_path__ + "static/media/addEvent.98f71f8686339fd5668b4f97109a618d.svg";
export { ForwardRef as ReactComponent };